import React, { useState } from 'react';
import { AlertTriangle, Loader2, Mail } from 'lucide-react';
import { Button } from './ui/button';
import api from '../lib/api';
import { toast } from 'sonner';
import { useTranslation } from '../i18n';

export default function VerifyEmailBanner({
  user }) {
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);

  // Don't show for verified users or users without the field (existing accounts)
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post('/auth/resend-verification');
      toast.success('Verification email sent! Check your inbox.');
    } catch (err) {
      toast.error('Failed to send verification email');
    }
    setSending(false);
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-950 border-b border-amber-200 dark:border-amber-800 px-4 py-3">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <Mail className="h-5 w-5 text-amber-600 dark:text-amber-400 shrink-0" />
          <p className="text-sm text-amber-800 dark:text-amber-200">
            <span className="font-medium">Verify your email</span> — Check your inbox for a verification link to unlock all features.
          </p>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={resend}
          disabled={sending}
          className="shrink-0 border-amber-300 dark:border-amber-700 text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900"
        >
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Resend Email'}
        </Button>
      </div>
    </div>
  );
}
